import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton } from "@mantine/core";
export const LoadingCards = ({ numCards, height = 7.5, variableHeight = false }) => {
    return (_jsx(_Fragment, { children: Array.from(Array(numCards).keys()).map((index) => {
            return (_jsx(Skeleton, { variant: "card", style: {
                    height: `${variableHeight
                        ? Math.random() * (20 - 8) + 12
                        : height}rem`
                } }, index));
        }) }));
};
